import { intersection, cloneDeep } from 'lodash'

// 通过后台配置数据+个性设置缓存数据+快照数据进行合并处理后喂给个性设置弹窗组件使用 （新增字段、字段排序、显示隐藏）
export const mergeFormFields = (originArr, userArr, snapshotObj, options) => {
  if (!userArr) return

  const isHasSnapshot = snapshotObj && Object.keys(snapshotObj).length
  // 如果没有交集，则取公共模板
  const keys = intersection(originArr.map(v => v.propertyName), userArr)

  if (keys && keys.length > 0) {
    // 用户保存的字段排在 required 后面
    let min = 1
    originArr.forEach((v, i) => {
      if (v.required || (options[v.propertyName] && options[v.propertyName].required)) {
        v.required = true
        v.index = min
        min++
      }
    })
    originArr.forEach((v, i) => {
      const originField = cloneDeep(v)
      let index = userArr.indexOf(v.propertyName) + 1
      const snapshotObjItem = snapshotObj && snapshotObj[v.propertyName]
      let snapshotObjIndex = snapshotObjItem && snapshotObjItem.index
      let originArrIndex = i + min

      if (!v.required) {
        // 原始配置新增的字段
        if (snapshotObjIndex !== 0 && !snapshotObjIndex) {
          v.index = originArrIndex
          min += 1
        } else {
          v.index = snapshotObjIndex + min
        }
      }
      // Todo 2024-09-14 兼容处理：目前是通过是否存在缓存数据来判断，后续调整直接用快照字段show判断（快照之前的 show 获取不正确，已调整）
      v.show = index > 0 || v.required
      // 是否有用户数据，是否有上个版本数据
      if (isHasSnapshot) {
        updateFormFieldShowStatus(originField, v, snapshotObj)
      }
    })
    originArr.sort((a, b) => a.index - b.index)
  }
}

// 通过判断快照字段来更新字段显示状态
export const updateFormFieldShowStatus = (originField, v, snapshotObj) => {
  const isNewKey = !snapshotObj[v.propertyName] && originField.show
  // 上个版本没有字段，则表示该字段是新增字段
  v.show = v.show || isNewKey
}



// WEBPACK FOOTER //
// ./src/public/components/query-table/module/form-field/index.js